import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import { isHourlyFixedBalanceAllowance } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'
import type Allowance from 'modules/timeoff/store/models/Allowance'

import type { Cycle } from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/allowanceStatUtils'

import Accrued from './Accrued'
import Advance from './Advance'
import Carryovers from './Carryovers'
import Incidence from './Incidence'

interface Props {
  accrued: number
  allowance: Allowance
  carryOver: number
  incidence: number
  currentCycle: Cycle
  nextCycle: Cycle | null | undefined
  advance: number
}

const AvailableTooltip = ({
  accrued,
  allowance,
  carryOver,
  incidence,
  currentCycle,
  nextCycle,
  advance,
}: Props) => {
  const isHourlyFixedBalance = isHourlyFixedBalanceAllowance(allowance)

  const title = allowance.isDays
    ? i18n.t('time_off.available_tooltip.available_days')
    : i18n.t('time_off.available_tooltip.available_hours')

  return (
    <Tooltip title={title}>
      <>
        <Accrued
          amount={accrued}
          currentCycle={currentCycle}
          isHourlyFixedBalance={isHourlyFixedBalance}
        />
        {carryOver > 0 && accrued > carryOver && (
          <Carryovers amount={carryOver} isHourlyFixedBalance={isHourlyFixedBalance} />
        )}
        {incidence > 0 && accrued > carryOver && (
          <Incidence allowanceIncidence={incidence} isHourlyFixedBalance={isHourlyFixedBalance} />
        )}
        {advance < 0 && (
          <Advance
            amount={advance}
            nextCycle={nextCycle}
            isHourlyFixedBalance={isHourlyFixedBalance}
          />
        )}
      </>
    </Tooltip>
  )
}

export default observer(AvailableTooltip)
